export function MarkdownWebAppScreenshot({
  src,
  alt,
  appName,
}: {
  src: string;
  alt?: string;
  appName: string;
}) {
  return (
    <figure className="not-prose my-8 overflow-hidden rounded-2xl border border-border/80 bg-card shadow-[var(--shadow-soft)]">
      <div
        aria-hidden
        className="relative flex h-10 items-center border-b border-border/80 bg-muted/45 px-3 sm:h-11 sm:px-4"
      >
        <div className="flex items-center gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-rose-400/80" />
          <span className="h-2.5 w-2.5 rounded-full bg-amber-400/85" />
          <span className="h-2.5 w-2.5 rounded-full bg-emerald-400/80" />
        </div>
        <div className="absolute left-1/2 flex h-6 max-w-[62%] -translate-x-1/2 items-center gap-1.5 rounded-md border border-border/70 bg-background/80 px-3 text-[11px] font-medium text-muted-foreground shadow-sm sm:h-7 sm:max-w-[70%] sm:text-xs">
          <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500/80" />
          <span className="truncate">{appName}</span>
        </div>
      </div>
      <img
        src={src}
        alt={alt ?? ""}
        loading="lazy"
        decoding="async"
        className="block w-full bg-white"
      />
    </figure>
  );
}
